<template>
  <section class="info-section">
    <h3
      class="section-title"
      :class="{ 'section-title--empty': histories.length === 0 }"
    >
      自治体連携履歴{{ histories.length === 0 ? ' 無し' : '' }}
    </h3>
    <table
      v-if="histories.length > 0"
      class="info-table"
    >
      <thead>
        <tr>
          <th class="date-col">
            連携提案日
          </th>
          <th class="agreed-col">
            同意有無
          </th>
          <th class="date-col">
            自治体連携日
          </th>
          <th class="partner-col">
            連携先
          </th>
          <th>補足</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="history in histories"
          :key="history.id"
        >
          <td class="date-cell">
            {{ displayValue(history.proposedAt) }}
          </td>
          <td class="agreed-cell">
            {{ displayValue(history.agreedLabel) }}
          </td>
          <td class="date-cell">
            {{ displayValue(history.cooperatedAt) }}
          </td>
          <td class="partner-cell">
            {{ displayValue(history.partner) }}
          </td>
          <td class="note-cell">
            {{ displayValue(history.note) }}
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script setup>
defineProps({
  histories: {
    type: Array,
    default: () => [],
  },
});

const displayValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};
</script>

<style lang="scss" scoped>
.info-section {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  padding: 10px;
  margin-bottom: 10px;
}

.section-title {
  color: #c8384f;
  font-size: clamp(16px, 1vw, 20px);
  line-height: 1.25;
  font-weight: 700;
  margin-bottom: 6px;
}

.section-title--empty {
  color: #888;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
}

.info-table thead {
  background: #efefef;
}

.info-table th,
.info-table td {
  text-align: left;
  border-bottom: 1px solid #e4e4e4;
  padding: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: #333;
  vertical-align: top;
}

.info-table td.date-cell {
  color: #999;
  white-space: nowrap;
}

.info-table th.date-col {
  white-space: nowrap;
}

.info-table th.agreed-col,
.info-table td.agreed-cell {
  width: 64px;
  word-break: break-word;
}

// 連携先は複数ある場合に改行区切りで縦に並べる。最長ラベル「児童相談所」(5文字)が折り返さない幅を確保する
.info-table th.partner-col,
.info-table td.partner-cell {
  min-width: 76px;
}

.info-table td.partner-cell {
  white-space: pre-line;
}

.note-cell {
  max-width: 160px;
  white-space: normal;
  word-break: break-word;
}
</style>
